import { render, staticRenderFns } from "./ossUpload.vue?vue&type=template&id=e4acab9e&scoped=true&"
import script from "./ossUpload.vue?vue&type=script&lang=js&"
export * from "./ossUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4acab9e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dgq/mei_bao_pro/insuranceagent-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e4acab9e')) {
      api.createRecord('e4acab9e', component.options)
    } else {
      api.reload('e4acab9e', component.options)
    }
    module.hot.accept("./ossUpload.vue?vue&type=template&id=e4acab9e&scoped=true&", function () {
      api.rerender('e4acab9e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ossUpload/ossUpload.vue"
export default component.exports